import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import {LoginUsers, Users, Projects, Employees, EmployeesConfig, HolidayConfig} from './data/user';

let _Users = Users;

export default {
    /**
     * mock bootstrap
     */
    bootstrap() {
        let mock = new MockAdapter(axios);

        // mock success request
        mock.onGet('/success').reply(200, {
            msg: 'success'
        });

        // mock error request
        mock.onGet('/error').reply(500, {
            msg: 'failure'
        });

        //登录（前台)
        mock.onPost('/login').reply(config => {
            debugger
            let {username, password} = JSON.parse(config.data);
            return new Promise((resolve, reject) => {
                let user = null;
                setTimeout(() => {
                    let hasUser = LoginUsers.some(u => {
                        if (u.username === username && u.password === password) {
                            user = JSON.parse(JSON.stringify(u));
                            user.password = undefined;
                            return true;
                        }
                    });

                    if (hasUser) {
                        resolve([200, {code: 200, msg: '请求成功', user}]);
                    } else {
                        resolve([200, {code: 500, msg: '账号或密码错误'}]);
                    }
                }, 1000);
            });
        });

        //编辑用户
        mock.onGet('/user/edit').reply(config => {
            let {id, name, addr, age, birth, sex} = config.params;
            _Users.some(u => {
                if (u.id === id) {
                    u.name = name;
                    u.addr = addr;
                    u.age = age;
                    u.birth = birth;
                    u.sex = sex;
                    return true;
                }
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        //新增用户
        mock.onGet('/user/add').reply(config => {
            let {name, addr, age, birth, sex} = config.params;
            _Users.push({
                name: name,
                addr: addr,
                age: age,
                birth: birth,
                sex: sex
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });


        //获取项目信息（分页）
        mock.onGet('/project/listpage').reply(config => {
            let page = config.page
            let name = config.name
            let pageSize = config.pageSize
            let mockProjects = Projects.filter(project => {
                if (name && project.name.indexOf(name) == -1) return false;
                return true;
            });
            let total = mockProjects.length;
            mockProjects = mockProjects.filter((u, index) => index < pageSize * page && index >= pageSize * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        items: mockProjects
                    }]);
                }, 1000);
            });
        });

        //获取员工信息
        mock.onGet('/employee/listpage').reply(config => {
            let page = config.page
            let name = config.name
            let mockEpms = Employees.filter(emp => {
                if (name && emp.name.indexOf(name) == -1) return false;
                return true;
            });
            let total = mockEpms.length;
            mockEpms = mockEpms.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        items: mockEpms
                    }]);
                }, 1000);
            });
        });

        //获取员工级别配置
        mock.onGet('/employeecfg/listpage').reply(config => {
            let page = config.page
            let mockEpmcs = EmployeesConfig.filter(epmc => {
                return true;
            });
            let total = mockEpmcs.length;
            mockEpmcs = mockEpmcs.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        items: mockEpmcs
                    }]);
                }, 1000);
            });
        });

        //节假日配置
        mock.onGet('/holiday/listpage').reply(config => {
            let page = config.page
            let mockHldyCfg = HolidayConfig.filter(epmc => {
                return true;
            });
            let total = mockHldyCfg.length;
            mockHldyCfg = mockHldyCfg.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        items: mockHldyCfg
                    }]);
                }, 1000);
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/mock/mock.js